module.exports = __webpack_public_path__ + "img/paper-3.249a3365.png";